<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="wccard px-3 py-2 mb-3px">
  <div class="row">
    <div class="col d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0 text-webbtree-green pointer" (click)="handleBackEvent()">
          <i class="fa-regular fa-arrow-left"></i> Back
        </p>
        <div class="ml-2">
          <p class="font-weight-600" [ngClass]="jobDetails?.data?.location ? 'mb-1' : 'mb-0'">{{jobDetails?.data?.name | titlecase}}</p>
          <p class="m-0 text-9696 f-12" *ngIf="jobDetails?.data?.location">
            <i class="fa-regular fa-location-dot mr-1"></i>
            {{jobDetails?.data?.location | titlecase}}
          </p>
        </div>


      </div>

      <div *ngIf="jobDetails?.data?.source == 'create'">
        <span matTooltip="Rename" matTooltipClass="red-tooltip text-black" class="ml-2 pointer"
          (click)="openRenameProjectModel(jobDetails)">
          <i class="fa-regular fa-ellipsis-vertical"></i>
        </span>
      </div>
    </div>
  </div>

</div>


<!-- For Choose tab -->
<div class="wccard  px-3 py-2  mb-3px">
  <div class="row">
    <div class="col pl-0">
      <span class="f-14 pointer" [ngClass]="{ 'tabActive': showProjectDetailsTab, 'tabBtn': !showProjectDetailsTab }"
        (click)="onTabChange('project-tab')">
        Project Details
      </span>
      <span class="f-14 pointer"
        [ngClass]="{ 'tabActive': showEvaluationCriteriaTab, 'tabBtn': !showEvaluationCriteriaTab }"
        (click)="onTabChange('evaluation-tab')">
        Screen<sup><span>AI</span></sup> Evaluation Criteria
      </span>
    </div>
  </div>
</div>


<!-- For Project Details -->
<div class="wccard px-3 py-1 mb-3px" *ngIf="showProjectDetailsTab">
  <div class="row mb-3">
    <div class="col">
      <div class="d-flex align-items-center justify-content-between">
        <span class="f-14 font-weight-600" style="color: #484B59;">Basic Details</span>
        <div class="p-1" style="background-color: #FFDE251A; opacity: 1;">
          <span class="f-14 font-weight-400" style="color: #969696;">
            <i class="fa-solid fa-circle-info" style="color: #FFED27;"></i>
            The Job Description cannot be modified once the job is created</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Job Title</p>
      <p class="f-14 font-weight-400 text-black mb-0">{{(jobDetails?.data?.name ? jobDetails?.data?.name : 'Not Available') | titlecase}}</p>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Function </p>
      <p class="f-14 font-weight-400 text-black mb-0">{{(jobDetails?.data?.industry ? jobDetails?.data?.industry : 'Not Available')  | titlecase}}</p>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Location </p>
      <p class="f-14 font-weight-400 text-black mb-0">{{(jobDetails?.data?.location ? jobDetails?.data?.location : 'Not Available') | titlecase}}</p>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col">
      <p class="f-14 font-weight-400 text-9696 mb-1">Description </p>
      <p class="f-14 font-weight-400 text-black mb-0" [innerHtml]="projectDescription"></p>

    </div>
  </div>

</div>

<!-- For Evaluation Criteria -->
<div class="wccard px-3 mb-3px" *ngIf="showEvaluationCriteriaTab">
  <div class="row">
    <div class="col">
      <app-screening-criteria [tab]="tab" [jobDetails]="jobDetails"></app-screening-criteria>
    </div>
  </div>
</div>

<!-- For Rename Project model -->
<ng-template #renameProjectModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="f-14 font-weight-600" id="experience">Rename Job</h5>

      <span class="f-14 font-weight-600"></span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <input data-testid="auto-app-job-details-input-1" [formControl]="renameProjectInput" placeholder="Enter Job Name" type="text"
        class="wc-form-control nobg">
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectError">Duplicate Tag</span>
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectInputSpecialCharError">Special Character Not
        Allowed</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-job-details-button-1" class="btn-trms-small mr-3" [ngClass]="{ 'text-center': showSpinnerLoader }" (click)="renameProject()"
          [disabled]="showSpinnerLoader || renameProjectInputSpecialCharError || renameProjectError">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Save'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- For Back Event Model -->
<ng-template #handleBackEventModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Are you sure you want to exit?
      </span>
      <!-- <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span> -->
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <p class="f-14 ">Unsaved progress will be lost.</p>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-job-details-button-2" class="btn-trms-white mr-3" (click)="handleBackEvent()">Confirm</button>
        <button data-testid="auto-app-job-details-button-3" class="btn-trms-small" (click)="dismiss()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>



<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
